import { client } from './client';
// Stats for the admin Reset DB dialog (safe, read-only).
export function getResetDatabaseStats() {
    return client.get('/dev/reset-database');
}
// FULL RESET: wipes every non-demo level and all its content on the server.
// Admin-only, and refused unless the code-only deploy switch allows it.
export function resetDatabase() {
    return client.post('/dev/reset-database', {});
}
